export default "__VITE_ASSET__BsUjYtBv__"